export function getResultTableDependsParams(
  matchType,
  secondBetMatchType,
  teamsPlay,
  numberOfTeeTimes,
  ballCount,
) {
  return () => {
    const quota = teamsPlay
      ? [
          { title: "", property: "displayName" },
          { title: "Quota total", property: "teamQuotaTotal" },
          { title: "$", property: "net" },
          {
            title: "",
            property: "info",
          },
        ]
      : [
          { title: "", property: "displayName" },
          { title: "Quota", property: "quota" },
          { title: "Total", property: "totalQuota" },
          { title: "$", property: "net" },
          {
            title: "",
            property: "info",
          },
        ];

    const quotaSkins = teamsPlay
      ? [
          { title: "", property: "displayName" },
          { title: "Quota total", property: "teamQuotaTotal" },
          { title: "Skins", property: "winCount" },
          { title: "$", property: "net" },
          {
            title: "",
            property: "info",
          },
        ]
      : [
          { title: "", property: "displayName" },
          { title: "Quota", property: "quota" },
          { title: "Total", property: "totalQuota" },
          { title: "Skins", property: "winCount" },
          { title: "$", property: "net" },
          {
            title: "",
            property: "info",
          },
        ];
    const quotaBirdie = teamsPlay
      ? [
          { title: "", property: "displayName" },

          { title: "Quota total", property: "teamQuotaTotal" },
          { title: "Total", property: "totalQuota" },
          { title: "Birdie", property: "winCount" },
          { title: "$", property: "net" },
          {
            title: "",
            property: "info",
          },
        ]
      : [
          { title: "", property: "displayName" },

          { title: "Quota", property: "quota" },
          { title: "Total", property: "totalQuota" },
          { title: "Birdie", property: "winCount" },
          { title: "$", property: "net" },
          {
            title: "",
            property: "info",
          },
        ];

    const strokePlayNet = [
      { title: "", property: "displayName" },
      {
        title: "Strokes",
        property: teamsPlay ? "teamNetSmallerNumberTotal" : "total",
      },
      { title: "$", property: "net" },
      {
        title: "",
        property: "info",
      },
    ];

    const strokePlayGross = [
      { title: "", property: "displayName" },
      {
        title: "Strokes",
        property: teamsPlay ? "teamGrossSmallerNumberTotal" : "totalGrossScore",
      },
      { title: "$", property: "net" },
      {
        title: "",
        property: "info",
      },
    ];

    const strokePlayNetSkins = [
      { title: "", property: "displayName" },
      {
        title: "Strokes",
        property: teamsPlay ? "teamNetSmallerNumberTotal" : "total",
      },
      { title: "Skins", property: "winCount" },
      { title: "$", property: "net" },
      {
        title: "",
        property: "info",
      },
    ];

    const strokePlayGrossSkins = [
      { title: "", property: "displayName" },
      {
        title: "Strokes",
        property: teamsPlay ? "teamGrossSmallerNumberTotal" : "totalGrossScore",
      },
      { title: "Skins", property: "winCount" },
      { title: "$", property: "net" },
      {
        title: "",
        property: "info",
      },
    ];
    const strokePlayNetBirdie = [
      { title: "", property: "displayName" },
      {
        title: "Strokes",
        property: teamsPlay ? "teamNetSmallerNumberTotal" : "total",
      },
      { title: "Birdie", property: "winCount" },
      { title: "$", property: "net" },
      {
        title: "",
        property: "info",
      },
    ];

    const strokePlayGrossBirdie = [
      { title: "", property: "displayName" },
      {
        title: "Strokes",
        property: teamsPlay ? "teamGrossSmallerNumberTotal" : "totalGrossScore",
      },
      { title: "Birdie", property: "winCount" },
      { title: "$", property: "net" },
      {
        title: "",
        property: "info",
      },
    ];

    const skinsGross = [
      { title: "", property: "displayName" },
      { title: "Skins", property: "winCount" },
      { title: "$", property: "net" },
      {
        title: "",
        property: "info",
      },
    ];

    const skinsNet = [
      { title: "", property: "displayName" },
      { title: "Skins", property: "winCount" },
      { title: "$", property: "net" },
      {
        title: "",
        property: "info",
      },
    ];

    const birdiePoolGross = [
      { title: "", property: "displayName" },
      { title: "Birdie", property: "winCount" },
      { title: "$", property: "net" },
      {
        title: "",
        property: "info",
      },
    ];

    const matchPlay = () => {
      const matchPlayBasicPayout = [
        { title: "", property: "displayName" },
        { title: "Ways", property: "ways" },
        // { title: "$", property: "net" },
        // {
        //   title: "",
        //   property: "info",
        // },
      ];
      if (teamsPlay) {
        if (numberOfTeeTimes === 1) {
          if (secondBetMatchType === 0) {
            return [
              { title: "", property: "displayName" },
              { title: "Quota total", property: "total" },
              // { title: "Quota total", property: "teamQuotaTotal" },
              { title: "Ways", property: "ways" },
              // { title: "$", property: "net" },
              // {
              //   title: "",
              //   property: "info",
              // },
            ];
          }
          return [
            { title: "", property: "displayName" },
            { title: "Ways", property: "ways" },
            // { title: "$", property: "net" },
            // {
            //   title: "",
            //   property: "info",
            // },
          ];
        }
        if (ballCount === 1) {
          matchPlayBasicPayout.splice(1, 0, {
            title: "Ball 1",
            property: "ball1",
          });
          matchPlayBasicPayout.splice(2, 0, {
            title: "Ball 2",
            property: "ball2",
          });
        }

        return matchPlayBasicPayout;
      }
      if (secondBetMatchType === 0) {
        return [
          { title: "", property: "displayName" },
          { title: "Quota", property: "quota" },
          { title: "Ways", property: "ways" },
          // { title: "$", property: "net" },
          // {
          //   title: "",
          //   property: "info",
          // },
        ];
      }
      return [
        { title: "", property: "displayName" },
        { title: "Ways", property: "ways" },
        // { title: "$", property: "net" },
        // {
        //   title: "",
        //   property: "info",
        // },
      ];
    };

    const matchPlayGrossSkins = [
      { title: "", property: "displayName" },
      { title: "Ways", property: "ways" },
      { title: "Skins", property: "winCount" },
      { title: "$", property: "net" },
      {
        title: "",
        property: "info",
      },
    ];

    const matchPlayNetSkins = [
      { title: "", property: "displayName" },
      { title: "Ways", property: "ways" },
      { title: "Skins", property: "winCount" },
      { title: "$", property: "net" },
      {
        title: "",
        property: "info",
      },
    ];

    const matchPlayGrossBirdie = [
      { title: "", property: "displayName" },
      { title: "Ways", property: "ways" },
      { title: "Birdie", property: "winCount" },
      { title: "$", property: "net" },
      {
        title: "",
        property: "info",
      },
    ];

    const matchPlayNetBirdie = [
      { title: "", property: "displayName" },
      { title: "Ways", property: "ways" },
      { title: "Birdie", property: "winCount" },
      { title: "$", property: "net" },
      {
        title: "",
        property: "info",
      },
    ];

    if (matchType === 0) {
      if (secondBetMatchType === 4 || secondBetMatchType === 5) {
        return quotaSkins;
      }
      if (secondBetMatchType === 6 || secondBetMatchType === 7) {
        return quotaBirdie;
      }
      return quota;
    }

    if (matchType === 1) {
      if (secondBetMatchType === 4 || secondBetMatchType === 5) {
        return strokePlayNetSkins;
      }

      if (secondBetMatchType === 6 || secondBetMatchType === 7) {
        return strokePlayNetBirdie;
      }
      return strokePlayNet;
    }

    if (matchType === 2) {
      if (secondBetMatchType === 4 || secondBetMatchType === 5) {
        return strokePlayGrossSkins;
      }

      if (secondBetMatchType === 6 || secondBetMatchType === 7) {
        return strokePlayGrossBirdie;
      }
      return strokePlayGross;
    }

    if (matchType === 3) {
      if (secondBetMatchType === 4 || secondBetMatchType === 5) {
        return matchPlayGrossSkins;
      }
      if (secondBetMatchType === 6 || secondBetMatchType === 7) {
        return matchPlayGrossBirdie;
      }
      return matchPlay();
    }

    if (matchType === 4) {
      return skinsGross;
    }

    if (matchType === 5) {
      return skinsNet;
    }

    if (matchType === 6 || matchType === 7) {
      return birdiePoolGross;
    }

    if (matchType === 8) {
      if (secondBetMatchType === 4 || secondBetMatchType === 5) {
        return matchPlayNetSkins;
      }
      if (secondBetMatchType === 6 || secondBetMatchType === 7) {
        return matchPlayNetBirdie;
      }
      return matchPlay();
    }

    return null;
  };
}
